interface OnboardingAnswer {
  question_key: string
  question: string
  answer_key: string
  answer: string
}

export default function useUpdateMode() {
  const params = new URLSearchParams(window.location.search)
  const isUpdate = params.get('mode') === 'update'

  const postToReactNative = (answer: OnboardingAnswer) => {
    if (isUpdate && window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'UPDATE_ANSWER',
          answer,
        }),
      )
    }
  }

  return { isUpdate, postToReactNative }
}
